<div
  class="max-content flex max-w-[800px] flex-col items-start gap-6 self-stretch p-8">
  <div class="typo-emphasis-3-mobile lg:typo-heading-3-desktop text-[#004165]">
    Auto redemption for Velocity Points
  </div>

  <div class="max-h-[490px] overflow-y-auto leading-6 lg:max-h-[688px]">
    If you want to elect to transfer your ANZ Reward Points to Velocity Points
    via auto-redemption, click
    <span class="whitespace-nowrap">‘Continue to Velocity’</span>, select your
    preferred Auto-Redemption setting, enter your Velocity membership number and
    select Submit.
  </div>

  <div
    class="flex flex-col items-start justify-end gap-4 self-stretch lg:flex-row">
    <ng-container *ngIf="velocityMembershipId$ | async as velocityMembershipId">
      <button
        class="typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop h-[46px] w-full rounded-[4px] border border-[#0072AC] bg-[#0072AC] px-6 py-0 text-white lg:order-2 lg:w-auto"
        (click)="onConfirmation(velocityMembershipId)">
        Continue to Velocity
      </button>
    </ng-container>

    <button
      (click)="onDismiss()"
      class="typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop h-[46px] w-full rounded-[4px] border border-[#0072AC] bg-white px-6 py-0 text-[#0072AC] lg:order-1 lg:w-auto">
      Skip for now
    </button>
  </div>

  <div class="flex items-start justify-end gap-2 self-stretch">
    <mat-checkbox (change)="onDoNotShowAgain($event)"></mat-checkbox>
    <div>Don’t show this again</div>
  </div>
</div>
